import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { NewsDetailsModel } from "../models/news-details.model";
import { NewsListModel } from "../models/news-list.model";

@Injectable({
    providedIn: 'root'
})
export class NewsService {

    constructor(private httpClient: HttpClient) { }

    public getNews(excludeRead: boolean): Observable<NewsListModel[]> {

        let excludeReadParamter = excludeRead ? `?excludeRead=true` : '';
        return this.httpClient.get<NewsListModel[]>(`${environment.api}/news${excludeReadParamter}`);
    }

    public getNewsDetails(id: string): Observable<NewsDetailsModel> {
        return this.httpClient.get<NewsDetailsModel>(`${environment.api}/news/${id}`);
    }
}
